import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';
import Cookies from 'js-cookie';

interface SessionState {
  loginToken: string;
}

const isStandalone = window.top === window;

const initialState: SessionState = {
  loginToken: (isStandalone && Cookies.get('_auth')) || '',
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setLoginToken: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.loginToken = action.payload;
      if (!isStandalone) return; // Don't set cookies in iframe
      if (state.loginToken) {
        Cookies.set('_auth', state.loginToken, {
          sameSite: 'strict',
          secure: true,
        });
      } else {
        Cookies.remove('_auth');
      }
    },
  },
});

export const selectCurrentLoginToken = (state: RootState) =>
  state.session.loginToken;

export default sessionSlice.reducer;
